(function () {
  "use strict";

  function theme() {
    return window.theme || {};
  }

  function proxyPath() {
    return String(theme().followProxyPath || "/apps/artfolio").replace(/\/$/, "");
  }

  function request(path, options) {
    return fetch(proxyPath() + path, Object.assign({
      credentials: "same-origin",
      headers: { accept: "application/json" }
    }, options || {})).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        body = body || {};
        body.status = res.status;
        body.ok = res.ok;
        return body;
      });
    });
  }

  function setStatus(root, text, isError) {
    var status = root.querySelector("[data-review-status]");
    if (!status) return;
    status.hidden = !text;
    status.textContent = text || "";
    status.classList.toggle("is-error", Boolean(isError));
  }

  function init() {
    document.querySelectorAll("[data-product-reviews]").forEach(function (root) {
      if (root.getAttribute("data-reviews-bound") === "true") return;
      root.setAttribute("data-reviews-bound", "true");
      var productId = root.getAttribute("data-product-id");
      var form = root.querySelector("[data-review-form]");
      var hint = root.querySelector("[data-review-hint]");
      if (!productId || !form) return;

      request("/reviews?product_id=" + encodeURIComponent(productId)).then(function (body) {
        if (body.status === 401 || body.login === false) return;
        if (body.existing) {
          form.hidden = true;
          setStatus(root, "You’ve already reviewed this print.", false);
          return;
        }
        if (body.purchased === false) {
          form.hidden = true;
          if (hint) hint.textContent = "Reviews are for verified buyers. This login has no order for this print yet.";
        }
      }).catch(function () {});

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var submit = form.querySelector("[data-review-submit]");
        var ratingEl = form.querySelector('input[name="rating"]:checked');
        var bodyEl = form.querySelector('textarea[name="body"]');
        var rating = ratingEl ? Number(ratingEl.value) : 0;
        var text = bodyEl ? String(bodyEl.value || "").trim() : "";
        if (rating < 1 || rating > 5 || text.length < 8) {
          setStatus(root, "Choose a rating and write a short note (8 characters or more).", true);
          return;
        }
        if (submit) submit.disabled = true;
        setStatus(root, "Sending…", false);
        request("/reviews", {
          method: "POST",
          headers: { accept: "application/json", "content-type": "application/json" },
          body: JSON.stringify({ product_id: productId, rating: rating, body: text })
        }).then(function (body) {
          if (submit) submit.disabled = false;
          if (body.error === "login_required") {
            window.location.href = (theme().accountLoginUrl || "/account/login") +
              "?return_to=" + encodeURIComponent(window.location.pathname);
            return;
          }
          if (body.error === "purchase_required") {
            setStatus(root, "Reviews are for verified buyers of this print.", true);
            return;
          }
          if (body.error === "already_reviewed") {
            form.hidden = true;
            setStatus(root, "You’ve already reviewed this print.", false);
            return;
          }
          if (!body.ok) {
            setStatus(root, "Could not save that review. Try again in a moment.", true);
            return;
          }
          form.hidden = true;
          setStatus(root, "Thank you — your review is on the page.", false);
          window.location.reload();
        }).catch(function () {
          if (submit) submit.disabled = false;
          setStatus(root, "Could not save that review. Try again in a moment.", true);
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
